import { format, isThisYear } from 'date-fns';
import { getDateLocale } from 'shared/i18n';

/**
 * Дата и время матча в ленте: «15 окт., 12:27». Дата есть и у сегодняшних матчей — лента идёт
 * сутками, и голое «12:27» не говорит, о каком дне речь. Год показываем, только если он не текущий.
 */
export function formatMatchTime(timestamp: number): string {
  const date = new Date(timestamp);
  const pattern = isThisYear(date) ? 'd MMM, HH:mm' : 'd MMM yyyy, HH:mm';

  return format(date, pattern, { locale: getDateLocale() });
}
